@if (!!client) {

<!-- Politique MFA -->
<div>
    <p-selectbutton
        [options]="policyOptions"
        [(ngModel)]="selectedPolicyCode"
        optionLabel="label"
        optionValue="code"
        (onChange)="onPolicyChange()">
    </p-selectbutton>
</div>

<!-- Description de la politique sélectionnée -->
@if (client.mfaPolicy.code === MfaPolicy.Optional) {
<p-message severity="secondary" icon="pi pi-info-circle" styleClass="mt-3 w-full">La double authentification n'est pas obligatoire. Chaque utilisateur peut choisir de l'activer depuis son profil. Votre société n'est pleinement protégée contre les accès non autorisés.</p-message>
}
@if (client.mfaPolicy.code === MfaPolicy.All) {
<p-message severity="success" icon="pi pi-shield" styleClass="mt-3 w-full">Tous les utilisateurs de cette société devront configurer la double authentification lors de leur prochaine connexion. Votre société sera ainsi protégée contre les accès non autorisés.</p-message>
}

<!-- Profils (mode partiel uniquement) -->
@if (client.mfaPolicy.code === MfaPolicy.Partial) {

<p-message severity="info" icon="pi pi-sliders-h" styleClass="mt-3 w-full">La double authentification sera obligatoire uniquement pour les utilisateurs dont le profil est activé ci-dessous. Les autres pourront l'activer volontairement depuis leur profil. Votre société sera ainsi protégée contre les accès non autorisés pour effectuer certaines actions sensibles.</p-message>

    <!-- Profils standard -->
    @if (standardProfileItems.length > 0) {
    <div class="my-4">
        <p class="font-bold mb-2">Profils standard</p>
        <div class="flex flex-column gap-2">
            @for (item of standardProfileItems; track item.profile.code) {
            <div class="flex align-items-center justify-content-between py-2 px-3 border-round surface-ground">
                <div class="flex align-items-center gap-2">
                    <span>{{ item.profile.label }}</span>
                    @if (item.profile.mfaRecommended) {
                    <p-tag value="Recommandé" severity="success" [rounded]="true"></p-tag>
                    }
                </div>
                <p-toggleswitch
                    [ngModel]="item.requiresMfa"
                    (ngModelChange)="onToggleStandardProfile(item, $event)">
                </p-toggleswitch>
            </div>
            }
        </div>
    </div>
    }

    <!-- Profils personnalisés -->
    @if (customProfiles.length > 0) {
    <div>
        <p class="font-bold mb-2">Profils personnalisés</p>
        <div class="flex flex-column gap-2">
            @for (profile of customProfiles; track profile.id) {
            <div class="flex align-items-center justify-content-between py-2 px-3 border-round surface-ground">
                <span>{{ profile.label }}</span>
                <p-toggleswitch
                    [ngModel]="profile.requiresMfa" [disabled]="!profile.canPerform(Activities.Update)"
                    (ngModelChange)="onToggleCustomProfile(profile, $event)">
                </p-toggleswitch>
            </div>
            }
        </div>
    </div>
    }

}

}
